/**
 * Session gate for authenticated layout — checks login cookies / user state.
 * Does not enforce feature RBAC; use ProtectedRoute / FeatureGate for UI gating only.
 */
import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../../pages/Auth/hooks/useAuth";

export default function PrivateRoute({ children }) {
  const { sessionExpired } = useAuth();
  if (sessionExpired) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};
